import { useState } from 'react';
import { homeFAQs } from '@/mocks/home';

export default function FAQSection() {
  const [openIdx, setOpenIdx] = useState<number | null>(null);

  return (
    <section className="py-16 md:py-24 bg-background-100">
      <div className="w-full max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block px-4 py-1.5 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium mb-4">
            常见问题
          </span>
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-4">
            您可能想知道
          </h2>
          <p className="text-foreground-500 text-sm md:text-base">
            关于 qiaojzx.cn 的常见疑问，这里都有答案。
          </p>
        </div>

        <div className="flex flex-col gap-3">
          {homeFAQs.map((faq, idx) => (
            <div
              key={idx}
              className="bg-background-50 rounded-xl border border-background-200/70 overflow-hidden"
            >
              <button
                className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer hover:bg-background-100/50 transition-colors"
                onClick={() => setOpenIdx(openIdx === idx ? null : idx)}
              >
                <span className="font-medium text-foreground-800 text-sm pr-4">{faq.question}</span>
                <div className={`w-5 h-5 rounded-full flex items-center justify-center flex-shrink-0 transition-colors ${openIdx === idx ? 'bg-primary-500 text-background-50' : 'bg-background-200 text-foreground-500'}`}>
                  <i className={`text-xs transition-transform duration-300 ${openIdx === idx ? 'ri-subtract-line' : 'ri-add-line'}`}></i>
                </div>
              </button>
              <div
                className={`transition-all duration-300 overflow-hidden ${
                  openIdx === idx ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
                }`}
              >
                <p className="px-5 pb-4 text-foreground-500 text-sm leading-relaxed">
                  {faq.answer}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}